import React, { useEffect, useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'overrideStyle',
})(({ theme, overrideStyle }) => ({
  width: overrideStyle ? undefined : "100%",
  height: overrideStyle ? 40 : 50,
  minWidth: overrideStyle ? "40%" : undefined,
  backgroundColor: "#f0c300",
  color: "grey",
  borderRadius: "50px",
  border: "1px solid #e5e1e1",
  fontWeight: "bold",
  textTransform: "none",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px",
  "&:hover": {
    backgroundColor: theme.palette.custom.blue,
    color: "white",
    "& .add-to-cart-text": {
      color: "white", 
    },
  },
  "&:disabled": {
    backgroundColor: "#E0E0E0",
    color: "#A0A0A0",
    opacity: "0.5",
  },

  [theme.breakpoints.down("md")]: {
    transform: "translateY(-15px)",
  },
}));

const AddToCartButton = ({
  price = 250,
  isDisabled,
  quotationDatas,
  handleAddToCart,
  hidePrice,
  overrideStyle = false
}) => {
  const [askForQuotation, setAskForQuotation] = useState(false);
  const ttcPrice = price;
  const httPrice = ttcPrice / (1 + 20 / 100);
  const theme = useTheme();

  useEffect(() => {
    setAskForQuotation(quotationDatas.isNeeded);
  }, [quotationDatas.isNeeded]);

  return (
    <StyledButton
      disabled={isDisabled}
      onClick={handleAddToCart}
      overrideStyle={overrideStyle}
      sx={{
        opacity: hidePrice ? 0 : 1,
        pointerEvents: hidePrice ? "none" : "auto",
        visibility: hidePrice ? "hidden" : "visible",
        transition: "opacity 0.3s ease",
      }}
    >
      {overrideStyle == false && (
      <Box
        sx={{
          height: "100%",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          opacity: "1",
          border: "1px solid #e5e1e1",
          borderRadius: "50px",
          minWidth: "80px",
          padding: "5px",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            flexGrow: 5,
            color: theme.palette.custom.ttcPrice,
            fontWeight: "bold",
            fontSize: { xs: "0.8rem", sm: "1rem", md: "0.7rem", lg: overrideStyle ? "0.75rem" : "0.85rem" },
          }}
        >
          {ttcPrice > 0 && <>{ttcPrice}€ TTC</>}
          {ttcPrice <= 0 && <>€ TTC</>}
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            flexGrow: 3,
            color: "#000",
            fontSize: {
              xs: "0.6rem",
              sm: "0.8rem",
              md: "0.5rem",
              lg: overrideStyle ? "0.6rem" :  "0.7rem",
            },
          }}
        >
          {httPrice > 0 && <>{httPrice.toFixed(2)}€ HT</>}

          {httPrice <= 0 && <> € HT</>}
        </Typography>
      </Box>
      )}
      <Typography
        className="add-to-cart-text"
        sx={{
          textAlign: "center",
          flexGrow: 1,
          fontSize: { xs: "1rem", sm: "1rem", md: "0.70rem", lg: overrideStyle ? "0.9rem" : "1rem" },
          fontWeight: "bold",
          color: "black",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: "90px",
        }}
      >
        Ajouter au panier
      </Typography>
    </StyledButton>
  );
};

export default AddToCartButton;
